// Dati del sito — aggiorna qui numero WhatsApp, nome boutique e capi in vetrina.
export const WHATSAPP_NUMBER = "393479809583";
export const BRAND_NAME = "Fantasia di Emma Tiberio";
export const INSTAGRAM_URL = "https://www.instagram.com/emma_abbigliamentodonna";
export const INSTAGRAM_HANDLE = "@emma_abbigliamentodonna";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_GENERAL_MESSAGE =
  "Ciao! Ho visto il vostro sito e vorrei qualche informazione.";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/18144397/pexels-photo-18144397.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior:
    "https://images.pexels.com/photos/8386651/pexels-photo-8386651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PRODUCTS = [
  {
    id: "trench-fluid",
    title: "Trench Fluid Trench", // PLACEHOLDER
    price: "€ 68,00", // PLACEHOLDER
    sizes: "Taglie: S, M, L • Tessuto stretch morbido", // PLACEHOLDER
    image:
      "https://images.unsplash.com/photo-1718837615361-912c983c7899?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxiZWlnZSUyMHRyZW5jaCUyMGNvYXQlMjB3b21lbnxlbnwwfHx8fDE3OTIxNDY3ODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Trench beige elegante con sciarpa di seta",
  },
  {
    id: "maglia-smeraldo",
    title: "Maglia Fine Smeraldo", // PLACEHOLDER
    price: "€ 45,00", // PLACEHOLDER
    sizes: "Taglia Unica confortevole • 100% filato soffice", // PLACEHOLDER
    image:
      "https://images.unsplash.com/photo-1670603917227-3fd6882dbf97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxncmVlbiUyMGtuaXQlMjBzd2VhdGVyfGVufDB8fHx8MTc5MjE0Njc4NXww&ixlib=rb-4.1.0&q=85",
    alt: "Maglione morbido in tono verde salvia",
  },
  {
    id: "abito-fantasia",
    title: "Abito Fantasia Midi", // PLACEHOLDER
    price: "€ 59,00", // PLACEHOLDER
    sizes: "Taglie: 42, 44, 46 • Linea fluida elegante", // PLACEHOLDER
    image:
      "https://images.pexels.com/photos/17901631/pexels-photo-17901631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Abito midi a fantasia floreale su appendiabiti",
  },
  {
    id: "pantalone-panna",
    title: "Pantalone Sartoriale Panna", // PLACEHOLDER
    price: "€ 52,00", // PLACEHOLDER
    sizes: "Taglie: 40, 42, 44, 46 • Taglio dritto impeccabile", // PLACEHOLDER
    image:
      "https://images.pexels.com/photos/2659787/pexels-photo-2659787.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Pantaloni palazzo sartoriali color panna",
  },
];
